export class ReportFactoryError extends Error {
  readonly code: string
  readonly status?: number

  constructor(code: string, status?: number) {
    super(code)
    this.name = 'ReportFactoryError'
    this.code = code
    this.status = status
  }
}

export type ReportFactoryConfig = {
  configVersion: string
  portfolios: {
    sheetName: string
    portfolioId: number
    benchmarkPercent: number
  }[]
  defaults: {
    groupBy: 'currency' | 'class'
    isAppliedAccountMTD: boolean
    useFullFundName: boolean
  }
}

export type ReportFactoryRequest = {
  reportType: 'mtd_performance_hk_excel'
  basedate: string
  configVersion: string
  portfolios: {
    portfolioId: number
    benchmarkPercent: number
  }[]
  groupBy: 'currency' | 'class'
  isAppliedAccountMTD: boolean
  useFullFundName: boolean
}

export type ReportFactoryAcceptedJob = {
  jobId: string
  status: 'QUEUED'
  statusUrl: string
}

export type ReportFactorySucceededJob = {
  jobId: string
  status: 'SUCCEEDED'
  downloadUrl: string
  filename: string
  noDataPortfolios: unknown[]
  urlExpiresAt: string
}

export type ReportFactoryJob =
  | { jobId: string; status: 'QUEUED' | 'RUNNING' }
  | ReportFactorySucceededJob
  | { jobId: string; status: 'FAILED'; failureCode: string }
